import { createContext } from "react"

export const AlertContext = createContext({
    showAlert: (title?: string, message?: string) => { }
});

export type MessageBoxProps = {
    position: string
}

export default function MessageBox(props: MessageBoxProps) {
    return (
        <div>
            <p>This is the alert box</p>
        </div>
    )
}